export default class ToggleFilter {

    constructor() {
        if (this.searchFilters = document.querySelector(".search-filters")) {
            this.searchFiltersTrigger = document.querySelector(".search-filters-trigger");
            this._toggleFilters();
        }
    }

    _toggleFilters() {
        this.searchFiltersTrigger.addEventListener("click", () => {
            this.searchFilters.classList.toggle("search-filters--active");
        });
    }
}